export const bankStatementConstants = {
  GET_REQUEST: 'BANK_STATEMENT_GET_REQUEST',
  GET_SUCCESS: 'BANK_STATEMENT_GET_SUCCESS',
  GET_FAILURE: 'BANK_STATEMENT_GET_FAILURE',
};
